import React, { useState, useEffect, useRef, useCallback } from "react";
import { Card, Alert, Typography, IconButton } from "@material-tailwind/react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { TablaTramites } from "./TablaTramites"; 
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { getToken } from '../../../Helpers/auth-helpers';
import Main from '../../../componentes/Main';
import { useTramites } from '../hooks/useTramites';
import Axios from 'axios';
import { set } from "react-hook-form";

// Componentes Locales

export const QuickSearch = ({ isOpen, onClose, onSelect }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [mensajeError,setMensajeError] = React.useState(null)
  const [showMessage,setShowMessage] = React.useState(null)

  const inputRef = useRef(null);
  // Foco automático al abrir y cierre con ESC
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
      const handleEsc = (e) => e.key === "Escape" && onClose();
      window.addEventListener("keydown", handleEsc);
      return () => window.removeEventListener("keydown", handleEsc);
    }
  }, [isOpen, onClose]);

  const handleSearch = async (e) => {
    if (e.key === "Enter") {
      if(query.length > 2){
        setLoading(true);
        console.log(query)
        handleOmniSearch(query);
        setLoading(false);
      }else{
            message('La búsqueda debe tener al menos 3 caracteres');
      }
    }
  };

  const message = (text)=>{
    setShowMessage(text)
    setTimeout(() => {
        setShowMessage(null)
    }, 3000);
  }

  const handleOmniSearch = useCallback(async (texto) => {
    if (texto.trim().length < 3) {
      setResultadosBusqueda([]);
      setIsSearching(false);
      message('La búsqueda debe tener al menos 3 caracteres');
      return;
    }
  
    const token = getToken();
    try {
      //setIsSearching(true);
      const { data: res } = await Axios.get(
        `${process.env.REACT_APP_API_UAD_BASE}/api/tramites/search-global/true/${token}?q=${texto}`
      );
      setResultadosBusqueda(res.listado || []);
      if(res.listado.length===0) message('No se encontraron datos');
      message('Se muestran cómo máximo 100 resultados.');
      setMensajeError(null)
    } catch (err) {
      console.error("Error:", err);
      setMensajeError(err?.response?.data?.message || 'Se produjo un error al obtener los datos')
    }
  }, []); // Dependencias vacías para que nunca cambie la referencia
  

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center pt-[10vh] px-4 backdrop-blur-sm bg-black/20 animate-fade-in">
      {/* Fondo clicable para cerrar */}
      <div className="absolute inset-0 -z-10" onClick={onClose} />

      <Card className="w-full max-w-4xl max-h-[70vh] shadow-2xl overflow-hidden bg-white border border-gray-200">
        <div className="p-4 border-b border-gray-100 flex items-center gap-3">
          <MagnifyingGlassIcon className="h-6 w-6 text-blue-500" />
          <input
            ref={inputRef}
            className="flex-1 text-lg outline-none bg-transparent placeholder-gray-400"
            placeholder="Búsqueda global de trámites..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleSearch}
          />
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-bold py-1 px-2 bg-gray-100 rounded text-gray-500">ESC</span>
            <IconButton variant="text" size="sm" onClick={onClose}>
              <XMarkIcon className="h-5 w-5" />
            </IconButton>
          </div>
        </div>

      {showMessage &&  <div className="flex w-full flex-col gap-2 p-4"><Alert color="amber"  className="p-4">{showMessage}</Alert></div>}

        <div className="overflow-y-auto p-4 bg-gray-50/30">
          {resultadosBusqueda.length > 0 ? (
            <div className="animate-slide-up">
              <TablaTramites 
                mensajeError={mensajeError}
                data={resultadosBusqueda} 
                noHeader={true}
                seleccionarTramite={(t) => {
                   onSelect(t);
                   onClose();
                }} 
              />
            </div>
          ) : (
            <div className="py-20 text-center text-gray-400">
              <MagnifyingGlassIcon className="h-12 w-12 mx-auto mb-4 opacity-20" />
              <Typography>Escriba y presione Enter para una búsqueda general de trámites.</Typography>
              <Typography>Puede buscar por nombre, descripción, código web...etc</Typography>
              <Typography>Recuerde que cada código web tiene un prefijo asociado a la región y tipo de trámite.</Typography>
              <Typography>Por ejemplo, podría buscar con R8AS a todos los trámites de ascenso de la región 8.</Typography>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};